import UsersWithAccessModal from './UsersWithAccessModal.component';

export default UsersWithAccessModal;
